"use client";

import { tsv } from "@faire/slate/lib/tsv";
import { SpinnerBase } from "@faire/slate/private/loading-spinner/SpinnerBase";
import {
  getSpinnerSize,
  getSpinnerStrokeWidth,
} from "@faire/slate/private/loading-spinner/utils";
import { useStrictLocalization } from "@faire/web/common/localization";
import React from "react";

export const ButtonLoading = ({ label }: { label?: string }) => {
  const size = getSpinnerSize("small");
  const strokeWidth = getSpinnerStrokeWidth("small");
  const { strictLocalize } = useStrictLocalization();
  const buttonLoadingCls = buttonLoadingStyle.cls();

  return (
    <span className={buttonLoadingCls}>
      <SpinnerBase
        aria-label={
          label ??
          strictLocalize({
            id: "LJ8sQp",
            defaultMessage: "Loading",
            description: {
              text: "Message for screen readers when buttons just show a loading spinner with no text",
            },
          })
        }
        color="currentColor"
        role="status"
        size={size}
        strokeWidth={strokeWidth}
      />
      {label ? <span aria-hidden="true">{label}</span> : null}
    </span>
  );
};
const buttonLoadingStyle = tsv({
  base: [
    "absolute top-0 right-0 bottom-0 left-0",
    "flex items-center justify-center gap-(--slate-dimensions-2)",
    "rounded-[inherit]",
    "text-inherit",
  ],
});
